<template>
    <div></div>
</template>

<script setup>
import { onBeforeMount, onMounted, reactive } from "vue";
import api from '@/api/base'
import { useService } from '@/utils/IndexDB'

const imageServive = useService('images');
const model = reactive({
    crumb: [],
});

const r = {};
r.model = model;
r.get = () => model;

r.getbase64 = async (fileId) => {
    if (!fileId) { return ''; }
    let base64;

    let data = await imageServive.get(fileId)
    if (!data) {
        try {
            let res = await api.getbase64(fileId);
            data = res.data;
            await imageServive.set(fileId, data)
        } catch (error) {
            console.log("取得圖片失敗", error);
        }
    }
    if (data) { base64 = data; }
    return base64;
}

r.setLoginInfo = (loginInfo) => {
    model.loginInfo = loginInfo;
    localStorage.setItem('LoginInfo', JSON.stringify(loginInfo))
}

r.setToken = (token) => {
    localStorage.setItem('AuthorizationToken', token)
}

defineExpose(r);
</script>

<style scoped></style>
